import { Button } from "@mui/material";

import { FormState } from "../types";

import { LOADING } from "./constants";

type Props = {
  formState: FormState;
  handleConfirm: () => void;
  updateFormState: (newState: Partial<FormState>) => void;
  isInvalid: () => boolean;
};

function SubmitButton({
  formState,
  handleConfirm,
  updateFormState,
  isInvalid,
}: Props) {
  const isLoading = formState.state === LOADING;

  return formState.fileError || formState.censusError ? (
    <Button
      variant="contained"
      onClick={() =>
        updateFormState({
          censusFile: null,
          censusError: null,
          fileError: null,
        })
      }
    >
      Re-Upload Census
    </Button>
  ) : (
    <Button
      variant="contained"
      loading={isLoading}
      disabled={isInvalid()}
      onClick={handleConfirm}
    >
      Submit
    </Button>
  );
}

export default SubmitButton;
